import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

import {LeadDataAPI, getDispositionAPI, getSubDispositionAPI} from "./../../../API/Caller/LeadAPI";
//import Sidebar from "./../Common/Sidebar";
//import Header from "./../Common/Header";
//import Loader from "./../../Loader";
import Paginate from "./../../../utils/Pagination";
import Layout from "./../Layout";
import ContentLoader from "../../../utils/ContentLoader";
import ReactSelect from 'react-select';
import "./../../../Public/css/leads_list.css";
import { Modal, Button, Offcanvas } from 'react-bootstrap';



const Lead = () =>{

    const [leads, setLeads] = useState([]);
    const [showleads, setShowLeads] = useState(true);
    const [loading, setLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [stages, setStages] = useState([]);
    const [dispositions, setDispositions] = useState([]);
    const [subdispositions, setSubDispositions] = useState([]);
    const [program, setPrograms] = useState([]);
    const [institute, setInstitutes] = useState([]);
    const [source, setSource] = useState([]);
    const [filterstage, setFilterStage] = useState([]);
    const [filterdisposition, setFilterDisposition] = useState([]);
    const [filtersubdisposition, setFilterSubDisposition] = useState([]);
    const [filterprogram, setFilterProgram] = useState([]);
    const [filterinstitute, setFilterInstitute] = useState([]);
    //const [filtersource, setFilterSource] = useState("");
    const [filteremail, setFilterEmail] = useState("");
    const [filtername, setFilterName] = useState("");
    const [isfilterpagination, setIsFilterPagination] = useState(false);
    const[showcustomdates, setShowCustomDates] = useState(false);
    const[btnapplyloader, setBtnApplyLoader] = useState(false);
    const[btnclearloader, setBtnClearLoader] = useState(false);
    const[datefilteroption, setDateFilterOption] = useState(null);
    const[startdate, setStartDate] = useState("");
    const[enddate, setEndDate] = useState("");
    const [filtersStored, setFiltersStored] = useState(null);
    const [filtercontact, setFilterContact] = useState("");
    const [sortby, setSortBy] = useState("");
    const [orderby, setOrderBy] = useState("");
    const [totalrecords, setTotalRecords] = useState(0);
    const [isleadfiltermodal, setIsLeadFilterModal] = useState(false);
    const [assignedstartdate, setAssignedStartDate] = useState(null);
    const [assignedenddate, setAssignedEndDate] = useState(null);
    const [sources, setSources] = useState([]);
    const [filtersource, setFilterSource] = useState([]);

    const [filtersDraft, setFiltersDraft] = useState({ 
                                                    filterstage: [],
                                                    filterdisposition: [],
                                                    filterprogram: [],
                                                    filterinstitute: [],
                                                    filterdateoption: "",
                                                    filterstartdate: "",
                                                    filterenddate: "",
                                                    filtername: "",
                                                    filteremail: "",
                                                    filtercontact: "",
                                                    filtersortby: "",
                                                    filtersortorder: "",
                                                    filterassignedstartdate: "",
                                                    filterassignedenddate: "",
                                                    filtersource: []
                                                });

    const perpagedata = 20;


    useEffect(() => {


            LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, "", setTotalRecords, setSources);

    }, []);

    useEffect(() => {

        console.log("Step 1");

        if (!filtersStored) return;

        console.log("Step 2");
        const params = new URLSearchParams();
        console.log("Step 3");
        Object.keys(filtersStored).forEach(key => {
            if (filtersStored[key]) {
                params.append(key, filtersStored[key]);
            }
        });

        console.log("Step 4");

        params.append("page", currentPage);
        params.append("per_page", perpagedata);
        console.log("Step 5");
        LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, params, setTotalRecords, setSources);

    }, [filtersStored, currentPage]);



    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

        setIsFilterPagination(true);

        setFiltersStored({
                            ...filtersDraft,
                            page: data.selected + 1
                        });

        //handleFilterLeads();        
    }

    const handleInputEmailFilter =(e) =>{

        setFilterEmail(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filteremail: e.target.value
                        }));
    }

    const handleFilterStage = (selstages) =>{
        console.log('Filter Stage=====' + JSON.stringify(selstages));

        setFilterStage(selstages);

        if(selstages)
        {
            let stagevalue = selstages.map(sgdatalist => sgdatalist.value);

            console.log('Selected stage value======' + stagevalue);

            setFiltersDraft(prev => ({
                            ...prev,
                            filterstage: stagevalue
                        }));

            getDispositionAPI(stagevalue, setDispositions);
        }
    }

    const handleFilterDispositon = (seldisposition) =>{
        console.log("Filter Disposition====" + JSON.stringify(seldisposition));

        setFilterDisposition(seldisposition);

        if(seldisposition)
        {
            let dispositionval = seldisposition.map(dpdatalist => dpdatalist.value);

            setFiltersDraft(prev => ({
                                ...prev,
                                filterdisposition: dispositionval
                            }));

            getSubDispositionAPI(dispositionval, setSubDispositions);
        }
    }

    /*const handleFilterSubdisposition = (e) =>{
        setFilterSubDisposition(e.target.value);
    }*/

    const handleFilterProgram = (selprogram) =>{
        console.log('Filter program====' + JSON.stringify(selprogram));

        setFilterProgram(selprogram);

        if(selprogram)
        {
            let programvalue = selprogram.map(prgdatalist => prgdatalist.value);


            setFiltersDraft(prev => ({
                                ...prev,
                                filterprogram: programvalue
                            }));
        }
    }

    const handleFilterInstitute = (selinstitute) =>{
        console.log('Filter institute====' + JSON.stringify(selinstitute));

        setFilterInstitute(selinstitute);

        if(selinstitute)
        {
            let institutevalue = selinstitute.map(instdatalist => instdatalist.value);


            setFiltersDraft(prev => ({
                                ...prev,
                                filterinstitute: institutevalue
                            }));
        }
    }

    /*const handleFilterSource = (e) =>{
        setFilterSource(e.target.value);
    }*/

    const handleInputNameFilter = (e) =>{
        setFilterName(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filtername: e.target.value
                        }));
    }

    const handleFilterContact = (e) =>{

        setFilterContact(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filtercontact: e.target.value
                        }));
    }

    const handleDateFilterOption = (e) =>{

        console.log(e.target.value);

        if(e.target.value === 'customdate')
        {
            setShowCustomDates(true);
        }
        else
        {
            setShowCustomDates(false);
        }

        setDateFilterOption(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterdateoption: e.target.value
                        }));

    }

    const handleStartDate = (e) =>{
        setStartDate(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterstartdate: e.target.value
                        }));
    }

    const handleEndDate = (e) =>{
        setEndDate(e.target.value);

        setFiltersDraft(prev => ({
                            ...prev,
                            filterenddate: e.target.value
                        }));
    }

    const handleApplyFilter = () =>{

        console.log('Filter Name====' + filtername);
        console.log('Filter Email====' + filteremail);
        console.log('Filter Disposition====' + filterdisposition);

        setFiltersStored({
                            ...filtersDraft,
                            page: 1
                        });

        setCurrentPage(1);

        setIsLeadFilterModal(false);
    }

    const handleResetFilter = (e) =>{

        setFilterStage("");
        setFilterDisposition("");
        setFilterProgram("");
        setFilterInstitute("");
        setDateFilterOption("");
        setStartDate("");
        setEndDate("");
        setFilterName("");
        setFilterEmail("");
        setFilterContact("");
        setAssignedStartDate("");
        setAssignedEndDate("");
        setFilterSource("");

        setFiltersDraft({
                    filterstage: "",
                    filterdisposition: "",
                    filterprogram: "",
                    filterinstitute: "",
                    filterdateoption: "",
                    filterstartdate: "",
                    filterenddate: "",
                    filteremail: "",
                    filtername: "",
                    filtercontact: "",
                    filterassignedstartdate: "",
                    filterassignedenddate: "",
                    filtersource: ""
        });

        setFiltersStored(null);
        setCurrentPage(1);
        
        //LeadsAPI(setLeads, setLeadCount, setPayAmount, currentPage, perpagedata, setPageCount, setDataLoader, null);
        LeadDataAPI(setLeads, setLoading, setShowLeads, currentPage, perpagedata, setPageCount, setStages, setPrograms, setInstitutes, "", setTotalRecords, setSources);
    }

    const handleLeadSort = (sortby, sortorder) =>{

        //const filterparams = new URLSearchParams();

        setSortBy(sortby);
        setOrderBy(sortorder);
        console.log('Step 7');
        const updatedFilters = {
            ...filtersDraft,
            filtersortby: sortby,
            filtersortorder: sortorder
        };

        setFiltersDraft(updatedFilters);
        setFiltersStored(updatedFilters);

        setCurrentPage(1);


    }

    const handleLeadFilterModal = () =>{
        setIsLeadFilterModal(!isleadfiltermodal);
    }

    const handleLeadFilterModalHide = () =>{
        setIsLeadFilterModal(false);
    }

    const handleAssignedDateRange = (dates) => {

        console.log("Assigned Dates====" + dates);

        if(!dates || (!dates[0] && !dates[1]))
        {
            
            console.log("assigned false condition");
            setAssignedStartDate("");
            setAssignedEndDate("");

            setFiltersDraft(prev => ({
                                ...prev,
                                filterassignedstartdate: "",
                                filterassignedenddate: ""
                            }));
        }
        else
        {
            console.log("assigned true condition");

            const [startdate, enddate] = dates;

            setAssignedStartDate(startdate);
            setAssignedEndDate(enddate);

            setFiltersDraft(prev => ({
                                ...prev,
                                filterassignedstartdate: format(startdate, "yyyy-MM-dd"),
                                filterassignedenddate: format(enddate, "yyyy-MM-dd")
                            }));

        }

    }

    const handleFilterSource = (selsource) =>{
        console.log('Filter source====' + JSON.stringify(selsource));

        setFilterSource(selsource);

        if(selsource)
        {
            let sourcevalue = selsource.map(sourcedatalist => sourcedatalist.value);


            setFiltersDraft(prev => ({
                                ...prev,
                                filtersource: sourcevalue
                            }));
        }
    }


    return(
    <Layout>
        <div className="content">

            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">Leads</h4>
                            </div>
                            <div className="col-4 text-end">

                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="row crm-filter-row-top align-items-center">

                        <div className="mb-1 d-flex  justify-content-end align-items-center">
                            <button className="btn btn-success me-2" onClick={handleLeadFilterModal}>
                                <i className="ti ti-filter me-2"></i> Filter
                            </button>

                            <button type="button" className="btn btn-dark" onClick={handleResetFilter}>
                                <i className="fa fa-undo me-2"></i>Clear Filter
                            </button>
                        </div>
                    </div>

                    <Offcanvas show={isleadfiltermodal} onHide={handleLeadFilterModalHide} placement="end" className="offcanvas-custom">
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title id="contained-modal-title-vcenter">Filter Leads</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <div class="row crm-filter-row-bottom align-items-end">
                                <div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">Stage</label>
                                    <ReactSelect className="" value={filterstage} onChange={handleFilterStage} options={stages} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Stage" isMulti></ReactSelect>


                                </div>
                                <div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">Disposition</label>
                                    <ReactSelect className="" value={filterdisposition} onChange={handleFilterDispositon} options={dispositions} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Disposition" isMulti></ReactSelect>


                                </div>
                                <div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">Program</label>
                                    <ReactSelect className="" value={filterprogram} onChange={handleFilterProgram} options={program} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Program" isMulti></ReactSelect>

                                </div>
                                <div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">Institute</label>
                                    <ReactSelect className="" value={filterinstitute} onChange={handleFilterInstitute} options={institute} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Institute" isMulti></ReactSelect>

                                </div>

                                {/*<div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">Source</label>
                                    <ReactSelect className="" value={filtersource} onChange={handleFilterSource} options={sources} menuPosition="fixed" classNamePrefix="crm-select" placeholder="Select Source" isMulti></ReactSelect>

                                </div>*/}

                                <div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">Assigned Date</label>
                                    <DatePicker  className="form-control" selected={assignedstartdate} onChange={ handleAssignedDateRange } startDate={assignedstartdate} endDate={assignedenddate} selectsRange isClearable placeholderText="Select assigned date range" />

                                </div>
                            </div>

                            <div class="row crm-filter-row-bottom align-items-end">
                                <div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">Date Range</label>
                                    <select className="form-select" name="date-filter" onChange={handleDateFilterOption} value={datefilteroption}>
                                        <option value="">Select Date</option>
                                        <option value="today">Today</option>
                                        <option value="yesterday">Yesterday</option>
                                        <option value="last7days">Last 7 Days</option>
                                        <option value="last30days">Last 30 Days</option>
                                        <option value="thismonth">This Month</option>
                                        <option value="lastmonth">Last Month</option>
                                        <option value="customdate">Custom Date</option>
                                    </select>
                                </div>
                                <div className={ showcustomdates ? 'col-md-12 mb-1' : 'col-md-12 mb-1 d-none'}>
                                    <label class="crm-filter-label">Start Date</label>
                                    <input className="form-control" type="date" name="startdate" placeholder="Start Date" onChange={handleStartDate} value={startdate} />
                                </div>
                                <div className={ showcustomdates ? 'col-md-12 mb-1' : 'col-md-12 mb-1 d-none'}>
                                    <label class="crm-filter-label">End Date</label>
                                    <input className="form-control" type="date" name="enddate" placeholder="End Date" onChange={handleEndDate} value={enddate} />
                                </div>

                                <div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">Name</label>
                                    <input className="form-control" type="text" name="filtername" onChange={handleInputNameFilter} placeholder="Enter name" value={filtername} />
                                </div>

                                <div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">Email</label>
                                    <input className="form-control" type="email" name="filteremail" onChange={handleInputEmailFilter} placeholder="Enter email" value={filteremail} />
                                </div>

                                <div className="col-md-12 mb-1">
                                    <label class="crm-filter-label">Phone</label>
                                    <input className="form-control" type="text" name="filtercontact" onChange={handleFilterContact} placeholder="Enter phone" value={filtercontact} />
                                </div>
                            </div>

                            <div class="crm-filter-actions">
                                <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleLeadFilterModalHide}>Close</button>

                                <button type="button" className="btn btn-primary me-2" onClick={handleApplyFilter}>
                                        <i className="ti ti-search me-2"></i>Apply Filter
                                </button>

                            </div>
                        </Offcanvas.Body>

                    </Offcanvas>
                </div>

                <div className="col-md-12">
                    <div className="card">

                        <div className="card-body">
                            <div className="mb-2">
                                <strong>Total Records:</strong> {totalrecords}

                                <span className="mx-3">
                                    <i class="ti ti-circle-filled fs-10 text-success me-1"></i> Success
                                </span>

                                <span className="mx-3">
                                    <i class="ti ti-circle-filled fs-10 text-danger me-1"></i> Failed
                                </span>

                                <span className="mx-3">
                                    <i class="ti ti-circle-filled fs-10 text-light me-1"></i> Duplicate
                                </span>
                            </div>

                            <div className="table-responsive table-wrapper">
                                {loading ?

                                    <ContentLoader />
                                :
                                <table className="table table-data-section" id="">
                                    <thead className="thead-light">
                                        <tr>
                                            {/*<th>#</th>*/}
                                            <th className="sortable-column">
                                                Name
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'name' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('name', 'ASC')}></i>
                                                    <i className={ sortby === 'name' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('name', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th className="sortable-column">
                                                Email
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'email' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('email', 'ASC')}></i>
                                                    <i className={ sortby === 'email' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('email', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th className="sortable-column">
                                                Contact
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'contact' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('contact', 'ASC')}></i>
                                                    <i className={ sortby === 'contact' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('contact', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th className="sortable-column">
                                                Location
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'location' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('location', 'ASC')}></i>
                                                    <i className={ sortby === 'location' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('location', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th className="sortable-column">
                                                Program
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'program' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('program', 'ASC')}></i>
                                                    <i className={ sortby === 'program' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('program', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th className="sortable-column">
                                                Institute
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'institute' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('institute', 'ASC')}></i>
                                                    <i className={ sortby === 'institute' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('institute', 'DESC')}></i>
                                                </span>
                                            </th>
                                            {/*<th className="sortable-column">
                                                Source
                                            </th>*/}
                                            <th className="sortable-column">
                                                Status                                                
                                            </th>
                                            <th className="sortable-column">
                                                Call Count
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'callcount' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('callcount', 'ASC')}></i>
                                                    <i className={ sortby === 'callcount' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('callcount', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th className="sortable-column">
                                                Assigned Date
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'assigneddate' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('assigneddate', 'ASC')}></i>
                                                    <i className={ sortby === 'assigneddate' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('assigneddate', 'DESC')}></i>
                                                </span>
                                            </th>
                                            <th className="sortable-column">
                                                Updated Date
                                                <span className="sort-icons">
                                                    <i className={ sortby === 'institute' && orderby === 'ASC' ? 'fa fa-angle-up active' : 'fa fa-angle-up'} onClick={()=>handleLeadSort('institute', 'ASC')}></i>
                                                    <i className={ sortby === 'institute' && orderby === 'DESC' ? 'fa fa-angle-down active' : 'fa fa-angle-down'} onClick={()=>handleLeadSort('institute', 'DESC')}></i>
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                    {
                                    leads && leads.length > 0  ?
                                        leads.map(lead =>
                                        (

                                            <tr key={lead.id}>
                                                <td>
                                                    <h6 class="d-flex align-items-center mb-1">
                                                            {lead.external_api_status === 1 ?
                                                                <i class="ti ti-circle-filled fs-10 text-success me-1"></i>    
                                                            :
                                                                (lead.external_api_status === 2 ?
                                                                <i class="ti ti-circle-filled fs-10 text-light me-1"></i>
                                                                :
                                                                    (lead.external_api_status === 3 ?
                                                                    <i class="ti ti-circle-filled fs-10 text-failed me-1"></i>
                                                                    :
                                                                    <></>
                                                                    )
                                                                )
                                                            }
                                                            
                                                            <Link to={`/caller/lead-profile/${lead.id}`} className="">
                                                            {lead.name}
                                                            </Link>
                                                        </h6>

                                                    
                                                </td>
                                                <td>{lead.email}</td>
                                                <td>{(lead.contact).replace(".00", "")}</td>
                                                <td>{lead.location}</td>
                                                <td>{lead.program}</td>
                                                <td>{lead.institute}</td>
                                                {/*<td>
                                                {lead.source === 'Google' || lead.source === 'google'  ?
                                                    <>Google</>
                                                :
                                                    (lead.source === 'Affiliate' ?
                                                        <>Affiliate</>
                                                    :
                                                        (lead.source === 'Instagram' ?
                                                            <>Instagram</>
                                                        :
                                                            (lead.source === 'Database' ?
                                                                <>Database</>
                                                            :
                                                                (lead.source === 'Reference' ?
                                                                    <>Reference</>
                                                                :
                                                                    <>Other</>
                                                                )
                                                            )
                                                        )
                                                    )
                                                }
                                                </td>*/}
                                                <td>
                                                    {lead.leadstatus ?
                                                        <span class="badge badge-tag badge-purple-light">{lead.leadstatus}</span>
                                                    :
                                                        <span>-</span>
                                                    }
                                                </td>
                                                <td>{lead.callcount}</td>
                                                <td> 
                                                    {lead.assigned_at !== "" && lead.assigned_at !== null ?
                                                        moment(lead.assigned_at).format('DD-MM-YYYY h:mm')
                                                    :
                                                        <>-</>
                                                    } 
                                                </td>
                                                <td>
                                                    {lead.calleddate !== "" && lead.calleddate !== null ?
                                                        moment(lead.calleddate).format('DD-MM-YYYY h:mm')
                                                    :
                                                        <>-</>
                                                    }
                                                </td>

                                            </tr>
                                        ))

                                    :

                                        <tr>
                                            <td colSpan="10">
                                                <p>No record found...</p>
                                            </td>
                                        </tr>
                                    }

                                    </tbody>
                                </table>
                                }
                            </div>
                        </div>
                    </div>

                    {pagecount > 1 ?
                    <div className="pagination-section mt-3">

                        <nav>
                            <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                        </nav>
                    </div>
                    :
                        <></>
                    }

                </div>
            </div>

        </div>
    </Layout>
    )
}

export default Lead;
